exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sort-toolbar-item.widget {\n    display: flex;\n    flex-flow: row;\n    margin-right: 3px;\n    align-items: center;\n}\n\n.sort-toolbar-item.widget:last-of-type {\n    margin-right: 0;\n}\n\n.sort-toolbar-item.widget .label {\n    font-size: 11px;\n    cursor: pointer;\n}\n\n.sort-toolbar-item.widget .toggle-reverse {\n    cursor: pointer;\n    height: 16px;\n}\n\n.sort-toolbar-item.widget.selected .label {\n    font-family: 'OrkneyMedium', sans-serif;\n    font-family: 11px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/sort-toolbar/item.css
// module id = 539
// module chunks = 0